import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Offset, OffsetClass, OffsetValueClass } from "../../../../Constant";
import { OFFSET_DATA, OFFSET_LIST } from "../../../../Data/UiKit/Grid";
import GridCommonCardFooter from "../Common/GridCommonCardFooter";

const OffsetCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={Offset} span={OFFSET_DATA} />
        <CardBody className="grid-showcase">
          <Row className="g-2">
            <Col sm="5" xs="4" className="offset-sm-3 offset-2"><span>col-5 offset-3</span></Col>
            {OFFSET_LIST.map(({ smallSize, extraSmallSize, className, item }, index) => (
              <Col sm={smallSize} xs={extraSmallSize} className={className} key={index}><span>{item}</span></Col>
            ))}
          </Row>
        </CardBody>
        <GridCommonCardFooter className={OffsetClass} valueClass={OffsetValueClass} />
      </Card>
    </Col>
  );
};

export default OffsetCart;
